export class EnumUtils {
    public static convertFlagEnumToArray<T extends number>(
        value: T | null | undefined,
        enumType: { [key: number]: T | string },
    ): T[] {
        if (!value) {
            return [];
        }

        const enumValues: T[] = [];

        for (const key in enumType) {
            const flag = enumType[key];

            if (typeof flag === "number" && flag > 0 && (value & flag) === flag) {
                enumValues.push(flag);
            }
        }

        return enumValues;
    }
}
